<h5>Personal Information</h5>

<ag-shr-change-log-detail-by-type
  [keysConfig]="personalInfoConfig"
  [changeLogs]="changeLogs"
></ag-shr-change-log-detail-by-type>
